<template>
   	<!-- Main Wrapper -->
        <div class="main-wrapper">
		
			<!-- Header -->
				<layout-header />
			<!-- /Header -->
			
			<!-- Sidebar -->
				<layout-sidebar />
			<!-- /Sidebar -->
			
			<!-- Page Wrapper -->
            <div class="page-wrapper">
			
				<!-- Page Content -->
                <div class="content container-fluid">
					
					<!-- Page Header -->
					<div class="page-header">
						<div class="row">
							<div class="col-sm-12">
								<h3 class="page-title">Attendance Reports</h3>
								<ul class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Dashboard</router-link></li>
									<li class="breadcrumb-item active">Attendance Reports</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /Page Header -->
					
						<!-- Content Starts -->
						<!-- Search Filter -->
					<div class="row filter-row">
						
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus">
								<input type="text" class="form-control floating">
								<label class="focus-label">Employee Name</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus select-focus">
									<select class="form-control floating select">
										<option>
											Jan
										</option>
										<option>
											Feb
										</option>
										<option>
											Mar
										</option>
									</select>
								<label class="focus-label">Month</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus select-focus">
									<select class="form-control floating select">
										<option>
											2020
										</option>
										<option>
											2019
										</option>
										<option>
											2018
										</option>
									</select>
								<label class="focus-label">Year</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<a class="btn btn-success btn-block"> Search </a>  
						</div>     
                    </div>
					<!-- /Search Filter -->
					
					<div class="row">
						<div class="col-md-12">
							<div class="table-responsive">
								<table class="table table-striped custom-table mb-0 datatable">
									<thead>
										<tr>
											<th>#</th>
											<th>Date</th>
											<th>Clock In</th>
											<th>Clock Out</th>
											<th>Work Status</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>1</td>
											<td>1 Jan 2020</td>
											<td>-</td>
											<td>-</td>
											<td>-</td>
										</tr>
										<tr>
											<td>2</td>
											<td>2 Jan 2020</td>
											<td>-</td>
											<td>-</td>
											<td>-</td>
										</tr>
										<tr>
											<td>3</td>
											<td>3 Jan 2020</td>
											<td>-</td>
											<td>-</td>
											<td>-</td>
										</tr>
										<tr>
											<td>4</td>
											<td>4 Jan 2020</td>
											<td colspan="3" class="text-danger text-center">Week Off</td>
										</tr>
										<tr>
											<td>5</td>
											<td>5 Jan 2020</td>
											<td colspan="3" class="text-danger text-center">Week Off</td>
										</tr>
										<tr>
											<td>6</td>
											<td>6 Jan 2020</td>
											<td>-</td>
											<td>-</td>
											<td>-</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
                
					<!-- /Content End -->
					
                </div>
				<!-- /Page Content -->
				
            </div>
			<!-- /Page Wrapper -->
			
        </div>
		<!-- /Main Wrapper -->
</template>

<script>
    export default {
        mounted() {
            // Select 2
            if ($('.select').length > 0) {
                $('.select').select2({
                    minimumResultsForSearch: -1,
                    width: '100%'
                });
            }
        },
        name: 'projectreports'
    }
</script>


// WEBPACK FOOTER //
// src/components/attendancereports.vue